export default "__VITE_ASSET__69c8472f__"